import dtu from '/public/assets/customers/white/dtu.svg';
import energia from '/public/assets/customers/white/energia.svg';
import frederiksberg from '/public/assets/customers/white/frederiksberg.svg';
import helsingor from '/public/assets/customers/white/helsingor.svg';
import northampton from '/public/assets/customers/white/northampton.svg';
import oister from '/public/assets/customers/white/oister.svg';

export const Logos = () => (
  <div className="flex w-full flex-col items-center gap-12 overflow-hidden">
    <div className="flex justify-center gap-8 opacity-50">
      <img className="w-36" src={dtu} alt="dtu-logo" />
      <img className="w-36" src={energia} alt="energia-logo" />
      <img
        className="hidden w-36 md:flex"
        src={frederiksberg}
        alt="frederiksberg-logo"
      />
      <img className="w-36" src={helsingor} alt="helsingor-logo" />
      <img className="w-36" src={northampton} alt="northampton-logo" />
      <img className="hidden w-36 md:flex" src={oister} alt="oister-logo" />
    </div>
  </div>
);
